import { useDialog } from '@hooks/useDialog';

import './ImageDialog.css';

interface ImageDialogProps {
	imageUrl: string;
	isOpen: boolean;
	onClose: () => void;
}

export default function ImageDialog({ imageUrl, isOpen, onClose }: ImageDialogProps) {
	const { dialogRef, handleBackdropClick } = useDialog(isOpen, onClose);

	return (
		<dialog ref={dialogRef} className="sentinel-dialog" id="sentinel-image-dialog" onClick={handleBackdropClick} onCancel={onClose}>
			<div style={{ backgroundImage: `url(${imageUrl})` }} className="modal-inner-content">
				<button className="modal-close-btn icon icon-cross" onClick={onClose} aria-label="Close" autoFocus />
			</div>
		</dialog>
	);
}
